exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dropdown-body__main{max-height:240px;max-width:240px}", ""]);
